import { useCallback } from "react"
import { FMFile } from "../shared/FMFile"
import FManApi from "./FManApi"
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider"
import useShareDlg from "../components/Share/ShareDlg"

export default function useFileShare(){
    const {addSnackbar} = useSnackbar()
    const {showShare} = useShareDlg()

    const onShare = (files:FMFile[], duration:number) => (e:any) => FManApi.i.shareFiles(files.map(f => f._id), duration).then(showShare).catch(addSnackbar)
    const getShare = useCallback((files:FMFile[]) => {
        return  [
            {id:"10",text:"10 minutes",onClick:onShare(files, 10)},
            {id:"60",text:"1 hour",onClick:onShare(files, 60)},
            {id:"1440",text:"1 day",onClick:onShare(files, 1440)}
        ]
    }, [])

    return {getShare}
}